import { service } from '@ember/service';
import { Ability } from 'ember-can';
import type AuthzService from 'garaje/services/authz';
import type FeatureFlagsService from 'garaje/services/feature-flags';
import type StateService from 'garaje/services/state';
import { Permission } from 'garaje/utils/ui-permissions';

export default class VisitorEmailAbility extends Ability {
  @service declare authz: AuthzService;
  @service declare featureFlags: FeatureFlagsService;
  @service declare state: StateService;

  get canVisit(): boolean {
    return this.canManageVisitorGuide || this.canManageSurveyEmail || this.canManageWelcomeEmail;
  }

  get canVisitFlow(): boolean {
    return this.canManageSurveyEmail || this.canManageWelcomeEmail;
  }

  get canManageSurveyEmail(): boolean {
    return this.canManageVisitorEmails;
  }

  get canCustomizeEmail(): boolean {
    if (!this.canManageVisitorEmails) return false;

    const { vrSubscription, currentCompany } = this.state;
    return Boolean(
      this.featureFlags.isEnabled('email-customization', {
        createdAt: currentCompany.createdAt?.getTime(),
      }) &&
        (vrSubscription?.isPremiumPlan || vrSubscription?.isEnterprisePlan),
    );
  }

  // The core permission the other permissions all derive from
  get canManageVisitorEmails(): boolean {
    return this.authz.hasAnyPermissionAtCurrentLocation([
      Permission.VISITORS_LOCATION_CONFIGURATION_MANAGE_EMAIL,
      Permission.VISITORS_MAILER_TEMPLATE_MAPPING_CREATE,
      Permission.VISITORS_MAILER_TEMPLATE_MAPPING_DELETE,
      Permission.VISITORS_MAILER_TEMPLATE_MAPPING_UPDATE,
      Permission.VISITORS_VISITOR_GUIDE_SECTION_UPDATE,
      Permission.VISITORS_VISITOR_SURVEY_CONFIGURATION_UPDATE,
    ]);
  }

  get canManageWelcomeEmail(): boolean {
    if (!this.featureFlags.isEnabled('lobbyXpTfvEmail')) {
      return false;
    }

    const hasFeatureFlag = this.featureFlags.isEnabled('welcomeEmail');

    return hasFeatureFlag && this.canManageVisitorEmails;
  }

  get canManageVisitorGuide(): boolean {
    if (this.featureFlags.isEnabled('lobbyXp') && !this.featureFlags.isEnabled('lobbyXpTfvEmail')) {
      return false;
    }

    return this.canManageVisitorEmails;
  }
}
